export class Orders {
  Id : string='';
  PO : string='';
  NumarFactura : string='';
  ConditieLivrare : string='';
  DataReceptie : string='';
  Stare : string='';
}
